(function($, Drupal, once) {
  'use strict';

  Drupal.behaviors.certSenderContactStep = {
    attach: function(context, settings) {
      // Select from table in order to allow JS to reattach after "add more" callback
      const elements = jQuery(once('contact-step', 'table[data-drupal-selector="edit-recipients-items"]', context));
      elements.each(function() {
        let $formStepWrapper = $(this).parents('.form-wrapper[data-webform-key]');

        if ($formStepWrapper.data('webform-key') !== 'contact_step') {
          return;
        }

        jQuery('#paragraphsCollapse').collapse('hide');

        const $thisTable = $(this);
        const $recipientTypeRows = $thisTable.find('tbody > tr');

        $recipientTypeRows.each(function() {
          const $thisRow = $(this);
          const $thisSelectInput = $thisRow.find('select');
          const $thisTextInput = $thisRow.find('input[type="text"]');

          setRecipientFieldState($thisSelectInput, $thisTextInput);

          // Update select's input sibling on its change event.
          $thisSelectInput.on('change', function(event) {
            setRecipientFieldState($thisSelectInput, $thisTextInput);
          });
        });
      });
    }
  };

  /**
   * Set input attributes based on sibling select value.
   *
   * @param {*} $selectInput
   * @param {*} $textInput
   */
  function setRecipientFieldState($selectInput, $textInput) {
    const recipientType = $selectInput.val();

    // Remove the empty value
    $selectInput.find('option[value=""').each(function() {
      $(this).remove();
    });

    if (recipientType === 'fax') {
      $textInput.attr('type', 'tel');
      $textInput.attr('placeholder', '312-123-4567');
    }
    else {
      // If not fax, it means either nothing or "email" is the value,
      // which means we default to email type/placeholder.
      $textInput.attr('type', 'email');
      $textInput.attr('placeholder', 'email@website.com');
    }

    // Default selector to "email" if no value is set.
    if (!recipientType) {
      $selectInput.val('email');
    }
  }

})(jQuery, Drupal, once);
